import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { ProvideEnvironment } from '@rxap/environment';
import { HttpErrorInterceptor, ProvideErrorHandler } from 'angular-components/error-system';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { ProvideServiceWorkerUpdater, withDialogUpdater, withLogUpdater } from '@rxap/service-worker';
import { KeycloakBearerInterceptor } from 'eurogard-keycloak';
import { AuthHttpInterceptor, CorsInterceptor, ProvideAuthWithInitializer } from 'eurogard-authentication';
import { ProvideI18nMatIntl } from 'angular-components/localize/provide';
import { ProvideIconAssetPath } from 'angular-application-providers/provide-icon-asset-path';
import { ProvideErrorInterceptorOptions } from 'angular-application-providers/provide-error-interceptor-options';
import { MarkdownModule } from 'ngx-markdown';
import { LanguageInterceptor } from 'angular-services/user-area/language-interceptor';
import { ProvidePubSub } from '@rxap/ngx-pub-sub';
import { provideExternalAppsFilter } from 'angular-application-providers/provide-external-apps-filter';
import { provideTheme } from 'angular-services/theme/provide';
import { Angulartics2Module } from 'angulartics2';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(MarkdownModule.forRoot()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // required to be imported so that the http client is available in the application for the status check method
    importProvidersFrom(BsDropdownModule.forRoot(), MarkdownModule.forRoot(), Angulartics2Module.forRoot({ pageTracking: { clearQueryParams: true } })),
    provideHttpClient(
      withInterceptors([
        HttpErrorInterceptor,
        AuthHttpInterceptor,
        CorsInterceptor,
        KeycloakBearerInterceptor,
        LanguageInterceptor,
      ]),
    ),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAnimations(),
    ProvideErrorHandler(),
    ProvideAuthWithInitializer(),
    ProvideI18nMatIntl(),
    ProvideIconAssetPath(),
    ProvideErrorInterceptorOptions(),
    ProvideEnvironment(environment),
    ProvideServiceWorkerUpdater(withLogUpdater(), withDialogUpdater()),
    ProvidePubSub(),
    provideExternalAppsFilter(),
    provideTheme(),
  ],
};
